import React from 'react';

const SvgAlertTriangle = (props) => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="alert-triangle_svg__a"
        d="M9.88 3.449a3.002 3.002 0 0 1 5.135 0l8.478 14.154a3 3 0 0 1-2.576 4.5H3.966a3 3 0 0 1-2.557-4.514l8.47-14.14zM3.132 18.603a1 1 0 0 0 .844 1.5h16.929a1 1 0 0 0 .863-1.486L13.302 4.48a1 1 0 0 0-1.709-.002l-8.46 14.124zm8.314-9.5a1 1 0 0 1 2 0v4a1 1 0 1 1-2 0v-4zm.293 7.707a1 1 0 1 1 1.414-1.414 1 1 0 0 1-1.414 1.414z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="alert-triangle_svg__b" fill="currentColor">
        <use xlinkHref="#alert-triangle_svg__a" />
      </mask>
      <use
        fill="currentColor"
        fillRule="nonzero"
        xlinkHref="#alert-triangle_svg__a"
      />
      <g fill="currentColor" mask="url(#alert-triangle_svg__b)">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgAlertTriangle;
